<html>
    
     <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    <head>
       
    </head>
     <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
     <body>

        <h4 style="font-Family: 'Quicksand, Open Sans, Segoe UI, sans-serif';text-align:center; font-size:20px;">Payment with Card</h4>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <!-- a Stripe Element will be inserted here. -->
        <dx-validation-group>   
          <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
          <div class="fieldset">
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <div class = "half-width">
              <label for="cardname">Card Name</label>  

              <div class="nonstripe">
        
                <dx-text-box 
                  #cardname1
                  id="cardname1"
                  [(value)]="cardname"
                  [inputAttr]="{ autocomplete: 'chrome-off' }"
                  [showClearButton]="true" 
                  placeholder="Enter Card Name..."
                >
      
                    <dx-validator>
                      <dxi-validation-rule
                        type="required"
                        message="Card Name is Required"
                      >
                    
                      </dxi-validation-rule>
                    </dx-validator>
      
                </dx-text-box>

              </div>

            </div>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <br>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <div class = "half-width">
              <label for="emailaddress">Email Address</label>  
              <div class="nonstripe">
          
                <dx-text-box
                  id="emailaddress"
                  [(value)]="email"

                  [readOnly]="true"

                  [inputAttr]="{ autocomplete: 'chrome-off' }"

                  [showClearButton]="true" 
                  placeholder="Enter Email Address..."
                >

                    <dx-validator>
                        <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
                    
                        <dxi-validation-rule 
                            type="pattern"
                            [pattern]="emailPattern"
                            message="Invalid Email Name">
                        </dxi-validation-rule> 

                    </dx-validator> 
                    
                </dx-text-box>

              </div>

            </div>

          </div>
          <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
          <br>
          <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
          <div #stripeCard id="cardelement">

            <div class="fieldset">

              <div class = "half-width">
                <label for="cardelement-cardnumber">Card Number</label>
                <div id="cardelement-cardnumber"></div>
              </div>
              
              <div class="quarter-width">
                <label for="cardelement-cardexpiry">Card Exp MM/YY</label>
                <div id="cardelement-cardexpiry"></div>
              </div>

              <div class="quarter-width">
                <label for="cardelement-cardcvc">Card CVC</label>
                <div id="cardelement-cardcvc"></div>
              </div>

            </div>

          </div>
          <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->      
          <!-- Used to display form errors -->
          <div id="card-errors" role="alert"></div>
          <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
          <br>
          <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
          <div>
            <dx-button  
                #btnpayamt
                id="btnpayamt"
                [(text)]="btnpaytext"
                hint="Amount to be Paid"
    
                stylingMode="outlined"
                type="normal"
          
                height="40px"
                width="200px"

                [elementAttr]="{ class: 'buttonfieldset' }"

                (onClick)="createStripePay( $event, 1 )"
            >
    
            </dx-button>

            &nbsp;&nbsp;

            <dx-button  
                #btncancelamt
                id="btncancelamt"
                text ="Cancel Payment"
                hint="Cancel Payment"

                stylingMode="outlined"
                type="normal"
          
                height="40px"
                width="200px"

                [elementAttr]="{ class: 'buttonfieldset' }"

                (onClick)="createStripePay( $event, -1 )"
            >

            </dx-button>

            &nbsp;&nbsp;

            <dx-load-indicator 
                id="medium-indicator" 
                height="40" 
                width="40"
                [visible]="loadIndicatorVisible"    
            >
            </dx-load-indicator>
        </div>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <div id="elementoneline">
          <p id="cardstatus" hidden>Invalid</p>
          <p id="mmyystatus" hidden>Invalid</p>
          <p id="cvcstatus" hidden>Invalid</p>
        </div>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
      </dx-validation-group>
      <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->      
      <dx-toast
        [(message)]       =   "toastFileMessage"
        [(visible)]       =   "toastVisible"
        [type]            =   "toasttypeerror"
        [displayTime]     =   "toastdisplaytime" 
        [width]           =   "toastwidth" 
    >
           
          <dxo-position
            my="left"
            at="top"
            of="#cardname1"
          >

            <dxo-offset
              [x]="-140" 
              [y]="-50"
            >
            </dxo-offset>

          </dxo-position>

   </dx-toast>
   <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
     </body>
     <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
  </html>




